import { PublicClientApplication } from "@azure/msal-browser";

let msalInstance: PublicClientApplication | null = null;

export function setMsalInstance(instance: PublicClientApplication) {
  msalInstance = instance;
}

export function getMsalInstance() {
  return msalInstance;
}
